import { useLingui } from "@lingui/react";
import CancelBooking from "../../components/booking/CancelBooking";
import BackButton from "../../components/navigation/BackButton";
import Container from "../../components/Container.tsx";
import ContainerHeader from "../../components/ContainerHeader.tsx";
import { Trans } from "@lingui/react/macro";
import Infobox from "../../components/util/InfoBox.tsx";
import { useParams } from "react-router";
import { useAuth } from "react-oidc-context";
import { useUserBookingQuery } from "../../api/bookingApi.ts";

const CancelBookingPage = () => {
  const { i18n } = useLingui();
  const { bookingId } = useParams();
  const auth = useAuth();
  const { data: booking } = useUserBookingQuery(bookingId);

  const isTeacher = booking?.teacherId === auth.user?.profile.sub;
  const backTo = isTeacher
    ? "/mystudio/teacher-dashboard"
    : "/mystudio/bookings";

  return (
    <main className="flex w-full items-center justify-center px-4 pt-4">
      <Container className={"max-w-2xl min-w-1/2"}>
        <BackButton to={backTo} label={i18n._("Back to Bookings")} />
        <ContainerHeader>
          <Trans>Cancel Booking</Trans>
        </ContainerHeader>
        <Infobox>
          <Trans>
            Select the timeslots you want to cancel. The refund amount varies
            depending on the time until the teaching slot. If you still want to
            take the lesson but cannot join on the booked date, consider moving
            the lesson instead for free.
          </Trans>
          <ul className={"list-inside list-disc"}>
            <li>
              <Trans>90% until four weeks before</Trans>
            </li>
            <li>
              <Trans>50% until two weeks before</Trans>
            </li>
            <li>
              <Trans>not cancellable after that</Trans>
            </li>
          </ul>
        </Infobox>
        <CancelBooking onSuccessPath={backTo} />
      </Container>
    </main>
  );
};

export default CancelBookingPage;
